import {
    buildSchema,
} from "@camberi/firecms";

const sessionSchema = buildSchema({
    name: "sessions",
    properties: {
        title: {
            dataType: "string",
            title: "Title",
            validation: {
                required: true
            }
        },
        description: {
            dataType: "string",
            title: "Description",
            validation: {
                required: true
            },
            config: {
                multiline: true,

            }
        },
        theme: {
            dataType: "string",
            title: "Theme",

            // validation: {
            //     required: false

            // },
            config: {
                // field: CustomColorTextField,
                // fieldProps: {
                //     color: "red"
                // }

                enumValues: {
                    dark: "Dark",
                    light: "Light",
                }
            }
        },
        course_id: {
            title: "Course",
            dataType: "reference",
            description: "reference to course",
            collectionPath: "courses",
            previewProperties: ["title"],

        },
        group: {
            dataType: "string",
            title: "Group",
            // validation: {
            //     required: true
            // },
            config: {
                enumValues: {
                    sleep: "Sleep",
                    meditate: "Meditate",
                }
            }
        },
        type: {
            dataType: "string",
            title: "Type",
            validation: {
                required: true
            },
            config: {
                enumValues: {
                    premium: "Premium",
                    standard: "Standard",
                    free: "Free",
                }
            }
        },
        emotions: {
            dataType: "array",
            title: "Emotions",
            // validation: {
            //     required: true
            // },
            of: {
                dataType: "string",
                config: {
                    enumValues:
                    {
                        smile: "Smile",
                        happy: "Happy",
                        sad: "Sad",
                        love: "Love",
                        Grounded: "Grounded",
                        Overwhelmed: "Overwhelmed",
                        Anxious: "Anxious",
                        Calm: "Calm",
                        Joyful: "Joyful",
                        Stressed: "Stressed",
                        Depressed: "Depressed",
                        Angry: "Angry",
                        Caring: "Caring",
                        "In Pain": "In Pain",
                        Frustrated: "Frustrated",
                        Worried: "Worried",

                    }
                }
            }

            // of: {
            //     dataType: "reference",
            //     collectionPath: "emotions",
            //     schema: emotionSchema
            // }
        },
        tags: {
            dataType: "array",
            title: "Tags",
            // validation: {
            //     required: true
            // },
            of: {
                dataType: "string",
                config: {
                    enumValues:
                    {
                        smile: "Smile",
                        happy: "Happy",
                        sad: "Sad",
                        love: "Love",
                    }
                }
            }
        },
        cover: {
            title: "Cover",
            dataType: "string",
            description: "Cover image for session.",
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    storeUrl: true,
                }
            },
            validation: {
                required: true,
                requiredMessage: "Cover image is required for session."
            }
        },
        file: {
            title: "File",
            dataType: "string",
            description: "Music file for session",
            config: {
                storageMeta: {
                    mediaType: "audio",
                    storagePath: "audio",
                    acceptedFiles: ["audio/*"],
                    storeUrl: true,
                },
            }
        },
        time: {
            title: "Time",
            dataType: "number",
            description: "Duration of the music file. Exammple 5 min",
            validation: {
                required: true,
                min: 1,
                negative: false
            }

        },
        created_at: {
            dataType: "timestamp",
            title: "Created_at",
            autoValue: "on_create"
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated_at",
            autoValue: "on_update"
        },
        publish: {
            dataType: "boolean",
            title: "Publish",
            validation: {
                required: true
            }
        },
    }
});

sessionSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};
export default sessionSchema;